import { render } from "./Aside.vue?vue&type=template&id=1d94b689"
import script from "./Aside.vue?vue&type=script&lang=js"
export * from "./Aside.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__